module.exports = __webpack_public_path__ + "img/ss.21f63498.svg";